import { useRef, useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Wrapper, Content } from 'ui/sidebar';
import Breadcrumb from 'components/Breadcrumb';
import { CardTitle, PageHeader, Container, media } from 'ui';
import background from 'images/background-allovoisins.jpg';
import { getCurrentUser, getSelectedPlace } from 'selectors';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { allowedToAccessAlloVoisins } from 'utils/roles';
import { CardElement, CardElementContent } from '@tymate/sergic';


const AlloVoisinsCardTitle = styled(CardTitle)`
  font-size: ${({ theme }) => theme.size(4)};
  line-height: 1.3;
`;

const AlloVoisinsCard = styled(CardElement)`
  background: transparent;
  border: 0;
  padding: 0;

  ${media.desktop`
    background-image: url(${background});
    background-size: cover;
    background-position: left center;
    border: 0;
    font-size: ${({ theme }) => theme.size(1)};
    min-height: 600px;
  `}

  li {
    line-height: 1.5;
    font-weight: bold;
    font-size: ${({ theme }) => theme.size(1)};
  }
`;

const Grid = styled.div`
  display: flex;
  align-items: center;
`;

const Cell = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spacing(2)};

  ${({ variant }) =>
    variant === 'iframe' &&
    css`
      padding: 0 ${({ theme }) => theme.spacing()} 0;
      flex: 1;

      ${media.tablet`flex: 0 0 388px;`}
    `}
`;

const ContentCell = styled(Cell)`
  display: none;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  color: #fff;

  ${media.desktop`
    display: block;
  `}
`;

const AlloVoisins = () => {
  const iframeRef = useRef();
  const { currentIdentity } = useSelector(getCurrentUser);
  const place = useSelector(getSelectedPlace);
  const [initialized, setInitialized] = useState();

  const role = get(place, 'topPlaceRole.kind');

  const init = () => {
    if (!iframeRef.current) {
      setTimeout(init, 200);
      return;
    }

    const el = document.querySelector('.search-form-av');
    iframeRef.current.append(el);
  };

  useEffect(() => {
    setInitialized(true);
  }, []);

  useEffect(() => {
    if (!initialized) {
      return;
    }

    setTimeout(init);

    return () => {
      const el = document.querySelector('.search-form-av');
      document.body.append(el);
    };
    // eslint-disable-next-line
  }, [initialized]);

  if (!currentIdentity || allowedToAccessAlloVoisins.indexOf(role) === -1) {
    return null;
  }

  return (
    <>
      <Wrapper>
        <Content>
          <PageHeader>
            <Breadcrumb />
          </PageHeader>

          <Container leftAligned>
            <AlloVoisinsCard>
              <Grid>
                <ContentCell>
                  <CardElementContent hasEqualPadding>
                    <AlloVoisinsCardTitle>
                      Faites appel à l'un de nos membres pour répondre, à prix
                      malin, à vos besoins !
                    </AlloVoisinsCardTitle>

                    <ul>
                      <li>Petit bricolage</li>
                      <li>Services à la personne</li>
                      <li>Collecte de colis</li>
                      <li>Service aux animaux</li>
                      <li>Service informatiques</li>
                      <li>Tout autre besoin / service</li>
                    </ul>

                    <strong>
                      3 200 000 voisins échangent au quotidien partout en France
                      !
                    </strong>
                  </CardElementContent>
                </ContentCell>

                <Cell variant="iframe">
                  <div ref={iframeRef} />
                </Cell>
              </Grid>
            </AlloVoisinsCard>
          </Container>
        </Content>
      </Wrapper>
    </>
  );
};

export default AlloVoisins;
